var Curriculog = Curriculog || {};

Curriculog.SimpleConfirmDialog = (function ($, _, Backbone, SimpleConfirmDialog) {

	SimpleConfirmDialog = Curriculog.Dialog.extend({
		title: 'Warning',
		dialogClass: 'curriculog-dialog warning',
		itemType: 'itemType',
		itemName:'itemName',
		confirmButtonText: 'OK',
		cancelButtonText: 'Cancel',

		confirmCallback: function () {

		},

		cancelCallback: function () {
			this.close();
		},

		buttons: function () {
			buttons = {};
			buttons[this.confirmButtonText] = 'confirmCallback';
			buttons[this.cancelButtonText] = 'cancelCallback';
			return buttons;
		},
	});
	return SimpleConfirmDialog;

})($, _, Backbone, Curriculog.SimpleConfirmDialog || {});
